import { isNullable } from '@app/utils'

export const isNotNullable = (entity: unknown): entity is NonNullable<typeof entity> => !isNullable(entity)
